export default {
	SET_COUNTRIES(state, countries) {
		state.countries = countries
	},
	SET_VEHICLES(state, vehicles) {
		state.vehicles = vehicles
	},
	SET_CONTAINERS(state, containers) {
		state.containers = containers
	},
	SET_PACKAGES(state, packages) {
		state.packages = packages
	},
	SET_CARRIAGES(state, carriages) {
		state.carriages = carriages
	},
	SET_BUSINESS(state, business) {
		state.business = business
	},
	SET_ERPTYPES(state, erpTypes) {
		state.erpTypes = erpTypes
	}
}